jQuery(document).ready(function($){
  $('.sft-faq-accordion-content').hide();
  $('.sft-faq-accordion-header').removeClass('sft-faq-active');

  // Open first
  $('.sft-faq-accordion-content').first().show();
  $('.hr-faq .sft-faq-accordion-content').first().hide();
  $('.sft-faq-accordion-header').first().addClass('sft-faq-active');
  $('.hr-faq .sft-faq-accordion-header').first().removeClass('sft-faq-active');

  // Click event
  $('.sft-faq-accordion-header').on('click', function () {

    const $content = $(this).next('.sft-faq-accordion-content');

    // If already open → close it
    if ($content.is(':visible')) {
      $content.slideUp();
      $(this).removeClass('sft-faq-active');
      return;
    }

    // Close others
    $('.sft-faq-accordion-content').slideUp();
    $('.sft-faq-accordion-header').removeClass('sft-faq-active');

    // Open current
    $content.slideDown();
    $(this).addClass('sft-faq-active');

  });

  
  $('.cs-home-reviews .cs-content-slider-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
  });

  $('.cs-about-review .cs-content-slider-main').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
		{
		  breakpoint: 992,
		  settings: {
			slidesToShow: 2
		  }
		},
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow: 1
		  }
		}
	  ]
  });
  $('.hr-review-sec .cs-content-slider-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: true,
  });

  $('.cs-certificate-sec .cs-blurb-row').slick({
    slidesToShow: 3,
	  slidesToScroll: 1,
	  speed: 6000,        
	  autoplay: true,
	  autoplaySpeed: 0, 
	  cssEase: 'linear',   
	  infinite: true,
	  arrows: false,
	  dots: false,
	  pauseOnHover: false,
	  pauseOnFocus: false,
	  draggable: false,
	  swipe: false,
	  touchMove: false,
	  responsive: [
		{
		  breakpoint: 992,
		  settings: {
			slidesToShow: 4
		  }
		},
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow: 2
		  }
		}
	  ]
  });
  // Image Popup
  $('.cs-our-work .cs-blurb-img img').on('click', function () {
    $('#csPopupImg').attr('src', $(this).attr('src'));
    $('#csImagePopup')
      .css('display', 'flex')
      .hide()
      .fadeIn(200);
  });
  $('.cs-popup-close, #csImagePopup').on('click', function (e) {
    if (e.target !== this) return;
    $('#csImagePopup').fadeOut(200, function () {
      $(this).css('display', 'none');
    });
  });


  $('.secondary-header__toggle').on('click', function (e){
    $(this).toggleClass('cs-header-open');
    $('#MainContent').toggleClass('cs-second-menu-open');
    $('body').toggleClass('cs-body-over-hide');
  });

  $('.cs-popup-book').on('click', function (e){
    $('.book-appointment-popup').addClass('book-open');
    $('body').addClass('cs-body-over-hide');
  });
  
  $('.cs-pop-close').on('click', function (e){
    $('.book-appointment-popup').removeClass('book-open');
    $('body').removeClass('cs-body-over-hide');
  });

  $('.secondary-header__nav .has-submenu > a').on('click', function (e) {

    if ($(window).width() <= 989) {
      e.preventDefault();

      var parentItem = $(this).parent();

      // Close other open submenus
      parentItem
        .siblings('.has-submenu')
        .removeClass('open')
        .find('.sub-menu')
        .slideUp(200);

      // Toggle current submenu
      parentItem.toggleClass('open');
      parentItem.find('.sub-menu').slideToggle(200);
    }

  });

});

// document.addEventListener('DOMContentLoaded', function () {
//   const toggle = document.querySelector('.secondary-header__toggle');
//   const menu = document.getElementById('secondaryMenu');

//   if (toggle && menu) {
//     toggle.addEventListener('click', function () {
//       menu.classList.toggle('is-open');
//     });
//   }
// });


$('.secondary-header__toggle').on('click', function () {
    $(this).parent().parent().find('#secondaryMenu').toggleClass('is-open');
  });
